import React from "react";
var __jsx = React.createElement;
import { DateField } from "@/components/date-field";
/** Compact single-date filter chip; wraps the generic DateField. */
export function SingleDateFilter(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange,
    testId = _ref.testId,
    _ref$displayFormat = _ref.displayFormat,
    displayFormat = _ref$displayFormat === void 0 ? "MMM d, yyyy" : _ref$displayFormat;
  return /*#__PURE__*/React.createElement(DateField, {
    type: "single",
    variant: "filter",
    value: value !== null && value !== void 0 ? value : "",
    onChange: function onChange(next) {
      return _onChange(next || null);
    },
    testId: testId,
    label: label,
    placeholder: label,
    displayFormat: displayFormat
  });
}